import React, { useEffect, useState, useRef } from "react";
import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  ModalBodyBlack,
  ModalHeaderBlack,
  MyModal,
} from "../../../features/RadConnStyle";
import styled from "styled-components";

import BoostrapTable from "react-bootstrap-table-next";
import axios from "axios";
import { HttpJsonHeader } from "../../../features/Environments";
import { AiOutlineDelete, AiOutlinePlus } from "react-icons/ai";
import { GetConfirmTitle } from "../../components/ConfirmDialog";
import cellEditFactory from "react-bootstrap-table2-editor";

export default function GoodsModality(props) {
  // ********** Variable **********
  const [data, setData] = useState([]);
  const [reload, setReload] = useState(true);
  const objREF = useRef([]);

  useEffect(() => {
    if (reload || props.setShowModality) {
      loadList();
      setReload(false);
    }
  }, [reload, props.setShowModality]);

  // ********** RELOAD *********
  const loadList = () => {
    axios
      .post(
        process.env.REACT_APP_API + "api/goods/list-modality",
        { text: "ok" },
        HttpJsonHeader
      )
      .then((response) => {
        setData(response.data.rows);
      })
      .catch((err) => alert(err));
  };

  // ********** ADDNEW **********
  const doAddNew = () => {
    let ooo = objREF.current;
    if (ooo.GdModName.value === "") return;

    let saveData = {
      ModalityId: -1,
      ModalityName: ooo.GdModName.value,
      CreatedBy: props.user.userid,
    };
    axios
      .post(
        process.env.REACT_APP_API + "api/goods/modality-save",
        saveData,
        HttpJsonHeader
      )
      .then((res) => {
        setReload(true);
        ooo.GdModName.value = "";
      })
      .catch((err) => console.log(err));
  };

  //  ********** Update Data **********
  const beforeSaveCell = (oldValue, newValue, row, column, done) => {
    if (oldValue === newValue) {
      done(false);
      return;
    }

    let saveData = row;
    saveData[column.dataField] = newValue;
    saveData = { ...saveData, UpdatedBy: props.user.userid };

    axios
      .post(
        process.env.REACT_APP_API + "api/goods/modality-save",
        saveData,
        HttpJsonHeader
      )
      .then((res) => {
        done(true);
      })
      .catch((err) => console.log(err));
  };

  // ********** Delete **********
  const popupDelete = (row) => {
    props.setShowConfirm(true);
    let data = {
      GdModId: row.GdModId,
      DeletedBy: props.user.userid,
    };

    props.setConfirmAction({
      title: GetConfirmTitle("DELETE"),
      data: row,
      action: (row) => {
        axios
          .post(
            process.env.REACT_APP_API + "api/goods/modality-delete",
            data,
            HttpJsonHeader
          )
          .then((res) => {
            setReload(true);
          })
          .catch((err) => {
            console.log(err);
          });
      },
    });
  };

  const removeBox = (x, row) => {
    return (
      <div>
        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>ลบ</Tooltip>}
        >
          <Button
            variant="danger"
            className="info-button"
            onClick={() => {
              popupDelete(row);
            }}
          >
            <AiOutlineDelete />
          </Button>
        </OverlayTrigger>
      </div>
    );
  };

  const headerBox = (x, row) => {
    return (
      <div>
        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>บันทึก</Tooltip>}
        >
          <Button
            variant="info"
            className="info-button"
            onClick={() => doAddNew()}
          >
            <AiOutlinePlus />
          </Button>
        </OverlayTrigger>
      </div>
    );
  };

  //  ********** Field Style **********

  const fieldStyle = () => {
    return {
      border: "none",
      padding: "2px 5px 2px 5px",
      color: "var(--table-text-color)",
      alignItems: "center",
      justifyContent: "center",
    };
  };
  const headerColStyle = () => {
    return {
      justifyContent: "center",
      alignItems: "center",
      verticalAlign: "middle",
      border: "none",
      fontSize: "15px",
      backgroundImage: "linear-gradient(#3d3dd6,  #3d3dd6, #3d3dd6)",
    };
  };
  const headerFlagStyle = () => {
    return { ...headerColStyle(), width: "50px" };
  };

  const headerTextBox = (column, colIndex, { sortElement, filterElement }) => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "5px 0 0 0",
        }}
      >
        <div>
          <input
            type="text"
            className="textbox-40h"
            ref={(el) => {
              objREF.current[column.dataField] = el;
            }}
          />
        </div>
      </div>
    );
  };

  //  ********** Columns  **********
  const columns = [
    {
      dataField: "GdModName",
      text: null,
      align: "left",
      style: () => {
        return { ...fieldStyle(), paddingLeft: "25px" };
      },
      headerStyle: () => {
        return { ...headerColStyle(), minWidth: "200px" };
      },
      headerFormatter: headerTextBox,
    },

    {
      dataField: null,
      text: "",
      headerStyle: headerFlagStyle,
      align: "center",
      editable: false,
      formatter: removeBox,
      headerFormatter: headerBox,
    },
  ];

  return (
    <MyModal
      backdrop="static"
      show={props.showModality}
      size="sm"
      onHide={() => {
        props.setShowModality(false);
      }}
    >
      <ModalHeaderBlack closeButton> Modality</ModalHeaderBlack>
      <ModalBodyBlack>
        <MainPane>
          <LeftPane>
            <BoostrapTable
              bootstrap4
              keyField="GdModId"
              data={data}
              columns={columns}
              striped
              hover
              condensed
              headerClasses="headerWrapper"
              rowClasses={"table-next-rows-style"}
              // filter= {filterFactory()}
              cellEdit={cellEditFactory({
                mode: "click",
                blurToSave: true,
                beforeSaveCell: beforeSaveCell,
              })}

              // pagination = {paginationFactory( PageOptions)}
              // rowStyle = {rowStyle2}
              // rowEvents= {rowEvents}
            />
          </LeftPane>

          <RightPane></RightPane>
        </MainPane>
      </ModalBodyBlack>
    </MyModal>
  );
}

const MainPane = styled.div`
  display: flex;
  justify-content: center;
  min-height: 80vh;
  max-height: 80vh;
  overflow-y: scroll;

  /* background-color:red; */
`;

const LeftPane = styled.div``;

const RightPane = styled.div``;
